import ContentCopy from "@mui/icons-material/ContentCopy";
import { Box, Button, Tooltip } from "@mui/material";

import type { ButtonProps } from "@mui/material";
import type { FC } from "react";

export const DuplicateButton: FC<
  {
    onClick: () => void;
    disabled: boolean;
  } & ButtonProps
> = ({ onClick, disabled, ...props }) => (
  <Tooltip title={<Box sx={{ textAlign: "center" }}>Duplicate Template</Box>} placement="top" arrow>
    <Box>
      <Button
        data-analytics-id="email-design-copy-template"
        variant="outlined"
        disabled={disabled}
        onClick={onClick}
        type="button"
        {...props}
      >
        <ContentCopy data-testid="ContentCopyIcon" />
      </Button>
    </Box>
  </Tooltip>
);
